import React from 'react';

import styled from '@emotion/styled';

import { FontWeight, Text } from '@clutter/clean';

import {
  useGeocodeQuery,
  useOrderCancellationPolicyGroupQuery,
} from '@graphql/platform';

import { WT_VISITOR_TOKEN } from '@root/initializers/wt';

import { useSharedCheckoutContext } from '../context';
import { PolicyModal } from './subcomponents/policy_modal';

const Body = styled(Text.Body)`
  padding-top: 16px;
  padding-bottom: 40px;
`;

export const StorageCancellationModal: React.FC<{
  isOpen: boolean;
  handleModalClose(): void;
}> = ({ isOpen, handleModalClose }) => {
  const {
    flowState: { values },
  } = useSharedCheckoutContext();
  const geocode =
    useGeocodeQuery({
      variables: { zip: values.zip! },
      skip: !values.zip,
    }).data?.geocode ?? undefined;
  const { data } = useOrderCancellationPolicyGroupQuery({
    variables: {
      visitorToken: WT_VISITOR_TOKEN,
      orderScheduledTime: values.dateScheduled?.fromTime,
    },
    skip: !geocode || geocode?.region?.name === 'Los Angeles',
  });
  const cancellationPolicy =
    data?.orderCancellationPolicyGroup?.onboardingCancellationPolicy;
  return (
    <PolicyModal isOpen={isOpen} handleModalClose={handleModalClose}>
      <Text.Headline weight={FontWeight.Medium}>
        When will I be charged?
      </Text.Headline>
      <Body>
        Don’t worry, your reservation is completely free! Your card will not be
        charged until your appointment is complete.
      </Body>
      <Text.Headline weight={FontWeight.Medium}>
        What if I need to reschedule or cancel?
      </Text.Headline>
      <Body>
        {cancellationPolicy ? (
          <>{cancellationPolicy.paragraph}</>
        ) : (
          <>
            We ask that you reschedule or cancel at least 48hrs before your
            appointment. Otherwise, you will be charged a $100 charge. This
            charge is increased to $200 on the same day of the appointment. You
            can reschedule or cancel online in just a few clicks.
          </>
        )}
      </Body>
      <Text.Headline weight={FontWeight.Medium}>
        What if I cancel before my term is over?
      </Text.Headline>
      <Body>
        You may cancel your Subscription Services at any time once the minimum
        storage term has been met.
      </Body>
    </PolicyModal>
  );
};
